export const SESSION = {
  NAME: "geslub-session",
  PROPERTIES: {
    TOKEN: "authToken",
    USER_ID: "userId",
  },
};
